<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text  Aprobación de Coordenadas de Clientes

    v-dialog(v-model='dialog', persistent, max-width='1000px', lazy)
      v-container(style='background-color:white !important;')
        v-card-title.justify-center
          span.headline Detalles de la Solicitud
        v-card-text
          v-layout(row wrap)
            v-flex(xs12 md6)
              v-container(grid-list-md)
                v-layout(wrap)
                  v-flex(xs12, sm12)
                    v-text-field(
                      v-model='form.cliente',
                      label='Cliente',
                      readonly
                      outline
                      dense
                    )
                  v-flex(xs12, sm12)
                    v-text-field(
                      v-model='form.vendedor',
                      label='Vendedor',
                      readonly
                      outline
                      dense
                    )
                  v-flex(xs12, sm6)
                    v-text-field(
                      v-model='form.latitud',
                      label='Latitud',
                      readonly
                      outline
                      dense
                    )
                  v-flex(xs12, sm6)
                    v-text-field(
                      v-model='form.longitud',
                      label='Longitud',
                      readonly
                      outline
                      dense
                    )
                  v-flex(xs12)
                    v-textarea(
                      v-model='form.observacion',
                      label='Observación',
                      :disabled="form.estatus === 'Aprobado'"
                      outline
                      rows="3"
                      auto-grow
                    )
            v-flex(xs12 md6 style="height: 400px;")
              .map-container
                l-map(
                  ref="map"
                  :zoom="zoom"
                  :center="mapCenter"
                  style="height: 100%; width: 100%;"
                )
                  l-tile-layer(
                    :url="url"
                  )
                  l-marker(:lat-lng.sync="markerPosition")
                    v-card-actions(style="justify-content: center;")
          v-layout(row wrap justify-center)
            v-btn(
              v-if="form.estatus === 'Pendiente'"
              style="background:green;border-radius:10px; margin: 0 5px;" 
              flat 
              @click="aprobarCoordenada"
            ) Aprobar
            v-btn(
              v-if="form.estatus === 'Pendiente'"
              style="background:red;border-radius:10px; margin: 0 5px;" 
              flat 
              @click="rechazarCoordenada"
            ) Rechazar
            v-btn(
              style="background:black;border-radius:10px; margin: 0 5px;" 
              flat 
              @click="close"
            ) Cerrar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Solicitudes
        v-data-table.elevation-1(
          :headers='headers',
          :items='solicitudes',
          :loading='loading',
          :pagination.sync='pagination'
        )
          template(slot='items', slot-scope='props')
            td {{ (props.item.cliente && props.item.cliente) || 'N/A' }}
            td {{ (props.item.vendedor && props.item.vendedor) || 'N/A' }}
            td {{ formatDate(props.item.fechaCreacion) }}
            td
              v-chip(
                :color="getStatusColor(props.item.estatus)"
                dark
                small
              ) {{ props.item.estatus | capitalize }}
            td
              v-btn.mx-0(
                icon,
                @click='verDetalles(props.item)',
                :disabled="loading"
              )
                v-icon(color='green') edit
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon using CDN
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
export default {
  name: "CoordenadasClientes",
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data: () => ({
    loading: false,
    dialog: false,
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    zoom: 15,
    mapCenter: [10.0739, -69.3228],
    markerPosition: [10.0739, -69.3228],
    solicitudes: [],
    form: {
      _id: null,
      cliente: '',
      co_cli: '',
      co_ven: '',
      vendedor: '',
      latitud: '',
      longitud: '',
      estatus: 'Pendiente',
      observacion: '',
      fechaCreacion: null
    },
    headers: [
      { text: 'Cliente', value: 'cliente' },
      { text: 'Vendedor', value: 'vendedor' },
      { text: 'Fecha', value: 'fechaCreacion' },
      { text: 'Estado', value: 'estatus' },
      { text: 'Acciones', sortable: false }
    ],
    pagination: {
      sortBy: 'fechaCreacion',
      descending: true,
      rowsPerPage: 10
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  watch: {
    dialog(newVal) {
      if (newVal) {
        // Forzar la actualización del mapa cuando se abre el diálogo
        this.$nextTick(() => {
          if (this.$refs.map) {
            // Pequeño retraso para asegurar que el diálogo esté completamente visible
            setTimeout(() => {
              this.$refs.map.mapObject.invalidateSize();
            }, 100);
          }
        });
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  created() {
    this.verificacion();
    this.cargarSolicitudes();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsafiro.permisos.length; i++) {
        if (this.$store.state.adminsafiro.permisos[i].ruta === "CoordenadasClientes") {
          for (
            let j = 0;
            j < this.$store.state.adminsafiro.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    async cargarSolicitudes() {
      try {
        this.loading = true;
        const res = await Api.get('clienteCoordenadas');
        this.solicitudes = res.data;
      } catch (error) {
        console.error('Error al cargar solicitudes:', error);
        this.$swal('Error', 'No se pudieron cargar las solicitudes', 'error');
      } finally {
        this.loading = false;
      }
    },
    verDetalles(item) {
      this.form = item;
      if (item.latitud && item.longitud) {
        const lat = parseFloat(item.latitud);
        const lng = parseFloat(item.longitud);
        this.mapCenter = [lat, lng];
        this.markerPosition = [lat, lng];
      }
      this.dialog = true;
      
      // Forzar la actualización del mapa después de que el diálogo esté visible
      this.$nextTick(() => {
        if (this.$refs.map) {
          this.$refs.map.mapObject.invalidateSize();
        }
      });
    },
    async aprobarCoordenada() {
      try {
        this.loading = true;
        await Api.post(`clienteCoordenadas/${this.form._id}/aprobar`);
        this.$swal('¡Éxito!', 'Coordenada aprobada correctamente', 'success');
        this.close();
        this.cargarSolicitudes();
      } catch (error) {
        console.error('Error al aprobar coordenada:', error);
        this.$swal('Error', 'No se pudo aprobar la coordenada', 'error');
      } finally {
        this.loading = false;
      }
    },
    async rechazarCoordenada() {
      if (!this.form.observacion) {
        this.$swal('Advertencia', 'Debe ingresar una observación para rechazar', 'warning');
        return;
      }
      
      try {
        this.loading = true;
        await Api.post(`clienteCoordenadas/${this.form._id}/rechazar`, {
          observacion: this.form.observacion
        });
        this.$swal('¡Éxito!', 'Coordenada rechazada correctamente', 'success');
        this.close();
        this.cargarSolicitudes();
      } catch (error) {
        console.error('Error al rechazar coordenada:', error);
        this.$swal('Error', 'No se pudo rechazar la coordenada', 'error');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.form = {
        _id: null,
        cliente: '',
        vendedor: '',
        latitud: '',
        longitud: '',
        estatus: 'Pendiente',
        observacion: '',
        fechaCreacion: null
      };
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : 'N/A';
    },
    getStatusColor(estatus) {
      const colors = {
        Pendiente: 'orange',
        Aprobado: 'green',
        Rechazado: 'red'
      };
      return colors[estatus] || 'grey';
    }
  }
};
</script>

<style scoped>
/* Estilos para el contenedor del mapa */
.map-container {
  height: 100%;
  width: 100%;
  min-height: 400px;
}

/* Asegurar que el mapa ocupe todo el espacio */
.leaflet-container {
  height: 100%;
  width: 100%;
  z-index: 1;
}

/* Fix para los íconos del marcador */
.leaflet-default-icon-path {
  background-image: url('https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png');
}
</style>
